import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import axios from 'axios';
import { FORMAT, MAX_NUMBER_OF_GUESTS, DISPLAYABLE_FORMAT } from './ReservationForm.constants';
import { getSiteKey } from '../../../components/RecaptchaProvider/RecaptchaProvider.utils';
import { getBusinessTypePath } from '../../../utils/api';
import DateUtils from '../../../utils/date/DateUtils';
export function getNumberOfGuestsOptions() {
  var numberOfGuestsOptions = Array(MAX_NUMBER_OF_GUESTS).fill().map(function (_, i) {
    return {
      text: "".concat(i + 1),
      value: "".concat(i + 1),
      key: "".concat(i + 1)
    };
  });
  var finalOption = "".concat(MAX_NUMBER_OF_GUESTS + 1, "+");
  numberOfGuestsOptions.push({
    key: finalOption,
    value: finalOption,
    text: finalOption
  });
  return numberOfGuestsOptions;
}
export function getValidationMessage() {
  var formData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!formData.reservationTime) {
    return 'To request your reservation, please select a Reservation Time';
  }
  if (!formData.guestsNumber) {
    return 'To request your reservation, please select a Number of Guests';
  }
  if (!formData.phone) {
    return 'To request your reservation, please input a Mobile Phone Number';
  }
  return null;
}
export function stringifyReservationDate(reservationDate, reservationTime) {
  var date = DateUtils.parse(reservationDate, FORMAT);
  var displayableDate = DateUtils.format(date, DISPLAYABLE_FORMAT);
  return "".concat(displayableDate, " @ ").concat(reservationTime);
}
export function requestReservation(_x) {
  return _requestReservation.apply(this, arguments);
}
function _requestReservation() {
  _requestReservation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var businessId,
      businessType,
      locationId,
      formData,
      recaptchaToken,
      headers,
      url,
      fullUrl,
      payload,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          businessId = _ref.businessId, businessType = _ref.businessType, locationId = _ref.locationId;
          formData = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
          recaptchaToken = _args.length > 2 ? _args[2] : undefined;
          headers = {};
          url = process.env.SERVER_URL || process.env.STORYBOOK_SERVER_URL;
          fullUrl = "".concat(url, "businesses/").concat(getBusinessTypePath(businessType), "/").concat(businessId, "/locations/").concat(locationId, "/reservations/");
          payload = _objectSpread(_objectSpread({}, formData), {}, {
            'recaptcha-token': recaptchaToken,
            'recaptcha-site-key': getSiteKey()
          });
          return _context.abrupt("return", axios.post(fullUrl, payload, {
            headers: headers
          }));
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _requestReservation.apply(this, arguments);
}
export function getDefaultReservationDate(timezone) {
  return DateUtils.getTimezoneAwareNow(timezone, {
    format: FORMAT
  });
}
export function getDefaultReservationMaxDate() {
  return DateUtils.addDays(365, {
    format: FORMAT
  });
}